
    import { mount } from "svelte";
    import App from './GistEditor.svelte'
    import './gisteditor.css'
    const args = {
      target: document.getElementById("app"),
    };
    const app = mount(App, args);
  